import React from 'react';
import ConnectedMyRequests from '../containers/ConnectedMyRequests';

const MyRequests: React.FC = () => {
  return <ConnectedMyRequests />;
};

export default MyRequests;
